export const mapContextData = (context: any) => {
  const {
    deviceInformation,
    user: { expUserId, anonymous }
  } = context;
  const browser = context.userAgent;
  let displayFormatType = 'desktop';
  if (deviceInformation) {
    if (deviceInformation.tablet) {
      displayFormatType = 'tablet';
    } else if (deviceInformation.mobile) {
      displayFormatType = 'mobile';
    }
  }

  return {
    user_member_id: expUserId && expUserId !== -1 ? expUserId.toString() : '',
    is_logged_in_user: anonymous ? 'N' : 'Y',
    device: displayFormatType,
    browser
  };
};
export const privacyTrackingConsent = (context: any) => {
  const opInPrivacy = context && context.site && context.site.optInPrivacyInfo;
  const canTrack = opInPrivacy && opInPrivacy.canTrack;
  if (canTrack) {
    return true;
  }

  return false;
};
